import type { CatalogSkuLookupItem } from "./client";
import { catalogApi } from "./client";

const CATALOG_SKU_LOOKUP_PAGE_SIZE = 20;

export const catalogSkuLookupQueryKey = ["catalog", "skus", "lookup"] as const;

export async function catalogSkuLookupQueryFn(params: {
  search: string;
  pageParam: number;
}): Promise<{ items: CatalogSkuLookupItem[]; nextPage: number | null }> {
  const { search, pageParam } = params;
  const res = await catalogApi.lookupCatalogSkus({
    limit: CATALOG_SKU_LOOKUP_PAGE_SIZE,
    offset: (pageParam - 1) * CATALOG_SKU_LOOKUP_PAGE_SIZE,
    search: search.trim() || undefined,
  });
  const { data, meta } = res;
  const nextPage =
    meta.offset + data.length < meta.total ? pageParam + 1 : null;
  return { items: data, nextPage };
}

export async function catalogSkuLookupPreloadQueryFn(
  id: string,
): Promise<CatalogSkuLookupItem | null> {
  if (!id) return null;
  return catalogApi.getSkuLookup(id);
}

export function catalogSkuLookupGetLabel(item: CatalogSkuLookupItem): string {
  const oem = item.oemPartNo?.trim();
  const cond = item.condition ?? "—";
  const oemBit = oem ? ` · ${oem}` : "";
  return `${item.productName}${oemBit} (${cond})`;
}

export function catalogSkuLookupGetValue(item: CatalogSkuLookupItem): string {
  return item.id;
}
